import script from "./security-event-detail.vue?vue&type=script&setup=true&lang=ts"
export * from "./security-event-detail.vue?vue&type=script&setup=true&lang=ts"

import "./security-event-detail.vue?vue&type=style&index=0&id=5dbc7d62&scoped=true&lang=scss"

import exportComponent from "/data/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5dbc7d62"]])

export default __exports__